var exports = {
  "k": "x127c5a35--6930cf--container",
  "D": "x127c5a35--6930cf--container--redesign",
};

module.exports = exports;
